import { useListViewContext } from '@app/core/list-view/context/ListViewContext';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { GenericParser, useQueryState } from 'nuqs';
import { MessageDescriptor, useIntl } from 'react-intl';

export interface FragmentsOnlyMineFilterProps {
  name: string;
  label: MessageDescriptor | false;
  parser: GenericParser<boolean>;
  isActive?: boolean;
  onRemove?: () => void;
}

/**
 * Permanent "Solo míos" switch for the fragments ListView filter bar.
 */
export function FragmentsOnlyMineFilter({ name, label, parser }: FragmentsOnlyMineFilterProps) {
  const { $t } = useIntl();
  const { setFilterValue } = useListViewContext();
  const [value] = useQueryState(name, parser);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 40 }}>
      <FormControlLabel
        control={
          <Switch
            size="small"
            color="primary"
            checked={Boolean(value)}
            onChange={(_event, checked) => {
              setFilterValue(name, checked);
            }}
          />
        }
        label={label === false ? '' : $t(label)}
        sx={{
          m: 0,
          '& .MuiFormControlLabel-label': { typography: 'body2' },
        }}
      />
    </Box>
  );
}
